var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-layout',{attrs:{"toolbarActive":"","toolbarClass":"content-bg--3"},scopedSlots:_vm._u([{key:"toolbarBase",fn:function(){return [_c('div',{staticClass:"display-2 font-weight-bold text-xs-center"},[_vm._v("\n      Тех. поддержка\n    ")])]},proxy:true}])},[_c('support-form',{attrs:{"tabs":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }